import React, { Fragment, useEffect, useState } from "react"
import { Row, Col, Card, CardBody, Badge, Spinner, Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { map, range } from "lodash"
import Select from "react-select"
import { get } from "helpers/api_methods"

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from "react-bootstrap-table2-toolkit"

//actions
import { getQuotationDuplicate, getQuotations, updateQuatation } from "store/orders/actions"

import "../../assets/scss/datatables.scss"
import QuotationDetails from "./QuotationDetails"
import MyPagination from "components/Common/MyPagination"
import moment from "moment"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { AvField, AvForm } from "availity-reactstrap-validation"

const Quotation = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [searchText, setSearchText] = useState("")
  const [QDetails, setQDetails] = useState()
  const { quotation, loading } = useSelector(state => ({
    quotation: state.Orders.quotation,
    loading: state.Orders.quotationLoading,
  }))
  const [finalDateFormated, setFinalDateFormated] = useState({
    from: "",
    to: "",
  })

  //pagination
  const [limit] = useState("10")
  const [page, setPage] = useState(1)
  const [sort, setSort] = useState("all")
  const [documentTypeFilter, setDocumentTypeFilter] = useState("all")
  const [categoryFilter, setCategoryFilter] = useState("all")
  const [staffFilter, setStaffFilter] = useState("all")
  const [clientFilter, setClientFilter] = useState("all")
  const [staffList, setStaffList] = useState([])
  const [clientList, setClientList] = useState([])

  const totalPages = Math.ceil(quotation?.count / limit)
  const pages = range(1, totalPages + 1)

  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        const staffRes = await get("/account/staff/")
        if (Array.isArray(staffRes)) {
          setStaffList(staffRes)
        } else if (staffRes && Array.isArray(staffRes.results)) {
          setStaffList(staffRes.results)
        }
      } catch (err) {
        console.error("Failed to fetch staff list for filter", err)
      }

      try {
        const clientRes = await get("/order/client/")
        if (Array.isArray(clientRes)) {
          setClientList(clientRes)
        } else if (clientRes && Array.isArray(clientRes.results)) {
          setClientList(clientRes.results)
        }
      } catch (err) {
        console.error("Failed to fetch client list for filter", err)
      }
    }

    fetchFilterOptions()
  }, [])

  useEffect(() => {
    dispatch(
      getQuotations(
        searchText,
        page,
        finalDateFormated,
        sort,
        documentTypeFilter,
        categoryFilter,
        staffFilter,
        clientFilter
      )
    )
  }, [
    dispatch,
    page,
    searchText,
    finalDateFormated,
    sort,
    documentTypeFilter,
    categoryFilter,
    staffFilter,
    clientFilter,
  ])

  const columns = [
    {
      dataField: "client_name",
      text: "Client",
      sort: true,
    },
    {
      dataField: "care_of_name",
      text: "Staff",
      sort: true,
    },
    {
      dataField: "auto_id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "date_added",
      text: "Date",
      sort: true,
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
    },
    {
      dataField: "document_type",
      text: "Type",
      sort: true,
    },
    {
      dataField: "quotation_category",
      text: "Category",
      sort: true,
    },
    {
      dataField: "action",
      text: "Action",
    },
  ]

  const listChange = sortValue => {
    setSort(sortValue)
    console.log(sortValue)
    history?.push({
      pathname: location.pathname,
      search: `p=${page}&s=${sortValue}`,
      state: {
        page: page,
        sort: sortValue,
      },
    })
    // dispatch(getAllProducts(page, sortValue, totalItemLimit, ""))
  }

  const tableTitles = [
    {
      title: "All",
      value: "all",
    },

    {
      title: "Pending",
      value: "pending",
    },

    {
      title: "Approved",
      value: "approved",
    },

    {
      title: "Rejected",
      value: "rejected",
    },
  ]

  const documentType = [
    {
      title: "All",
      value: "all",
    },
    {
      title: "Quotation",
      value: "quotation",
    },
    {
      title: "Order",
      value: "order",
    },
  ]

  const categoryTypes = [
    { title: "All", value: "all" },
    { title: "Product", value: "product" },
    { title: "Service", value: "service" },
  ]
  const Status = status => {
    console.log(status)
    if (status === "pending") {
      return "info"
    }
    if (status === "Pending") {
      return "info"
    }
    if (status === "Approved") {
      return "success"
    }
    if (status === "approved") {
      return "success"
    }
    if (status === "rejected") {
      return "danger"
    }
    if (status === "duplicate") {
      return "warning"
    }
  }

  const handleDuplicate = quotationId => {
    dispatch(getQuotationDuplicate(quotationId))
    // dispatch(getQuotations("", "", "", ""))
  }

  const handleStatusChange = (quotationId, newStatus) => {
    // Update only the status field using PATCH method
    // Pass null for QuatationItem to ensure PATCH is used (empty object {} is truthy)
    const statusUpdate = { status: newStatus }
    dispatch(updateQuatation(null, statusUpdate, quotationId, null)) // Pass null as QuatationItem and history

    // Refresh the quotation list after a short delay to show updated status
    setTimeout(() => {
      dispatch(getQuotations(searchText, page, finalDateFormated, sort))
    }, 500)
  }

  // useEffect(() => {
  //   dispatch(getQuotationReport(finalDateFormated, sort))
  // }, [dispatch, finalDateFormated, sort])

  // const newQuotation = quotation?.results?.filter(
  //   item => item.status == "Pending"
  // )

  // const handlerQuot = () => {
  //   if (window.location.search) {
  //     return ""
  //   } else {
  //     return quotation?.results
  //   }
  // }

  const quotationData = map(quotation?.results, (item, index) => ({
    ...item,
    key: index,
    care_of_name: item?.care_of_name || "—",
    client_name: (
      <>
        <p>
          {item?.client_name} &nbsp;
          {item?.isDuplicate === true ? (
            <span className="text-warning">(copy)</span>
          ) : (
            ""
          )}
        </p>
      </>
    ),
    auto_id: <>
      {item?.display_quotation_no || item?.auto_id}
      {item?.revision_number > 1 && (
        <span
          style={{
            marginLeft: "8px",
            background: "#f0ad4e",
            color: "#fff",
            padding: "2px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            fontWeight: 700,
          }}
        >
          Rev. {item?.revision_number}
        </span>
      )}
    </>,
    date_added: moment(item.date_added).format("YYYY/MM/DD"),
    quotation_category: (
      <Badge
        style={{ textTransform: "capitalize" }}
        className={`font-size-12 badge-soft-${item.quotation_category === "product" ? "success" : "primary"}`}
        pill
      >
        {item.quotation_category || "—"}
      </Badge>
    ),
    status: (
      <div
        className="d-flex"
        style={{
          maxWidth: "150px",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Badge
          style={{ textTransform: "capitalize" }}
          className={"font-size-12 badge-soft-" + `${Status(item?.status)}`}
          pill
        >
          {item.status}
        </Badge>
        <UncontrolledDropdown>
          <DropdownToggle
            className="btn-sm"
            color="light"
            type="button"
            title="Change Status"
          >
            <i className="bx bx-edit-alt" />s
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              onClick={() => handleStatusChange(item.id, "pending")}
              disabled={item.status === "pending"}
            >
              <i className="bx bx-time text-info me-2" />
              Pending
            </DropdownItem>
            <DropdownItem
              onClick={() => handleStatusChange(item.id, "approved")}
              disabled={item.status === "approved"}
            >
              <i className="bx bx-check-circle text-success me-2" />
              Approved
            </DropdownItem>
            <DropdownItem
              onClick={() => handleStatusChange(item.id, "rejected")}
              disabled={item.status === "rejected"}
            >
              <i className="bx bx-x-circle text-danger me-2" />
              Rejected
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    ),
    document_type: (
      <div
        className="d-flex"
        style={{
          maxWidth: "150px",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Badge
          style={{ textTransform: "capitalize" }}
          className={`font-size-12 badge-soft-${item.document_type == "order" ? "primary" : item.document_type == "quotation" ? "warning" : "danger"}`}
          pill
        >
          {item.document_type}
        </Badge>
      </div>
    ),
    action: (
      <Link
        type="button"
        className="btn-sm btn-info btn-rounded"
        to="#"
        onClick={() => setQDetails(item.id)}
      >
        <i className="bx bx-show-alt font-size-16" title="View Details" />
        &nbsp; &nbsp;
        <i
          onClick={() => handleDuplicate(item?.id)}
          style={{ cursor: "pointer" }}
          className="bx bx-duplicate font-size-16 text-primary"
          title="Duplicate"
        />
      </Link>
    ),
  }))

  const staffOptions = [
    { value: "all", label: "All Staff" },
    ...staffList.map(s => {
      const fullName = `${s.first_name || ""} ${s.last_name || ""}`.trim() || s.username
      return { value: s.id, label: fullName }
    }),
  ]

  const clientOptions = [
    { value: "all", label: "All Clients" },
    ...clientList.map(c => ({
      value: c.id,
      label: c.name,
    })),
  ]

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  // Select All Button operation
  const selectRow = {
    mode: "checkbox",
  }

  const handleSearch = e => {
    setSearchText(e.target.value)
  }

  console.log(quotation?.results?.length)

  console.log(page)

  return (
    <React.Fragment>
      <Row>
        <Col md={6}>
          <Card style={{ height: 120, borderRadius: 15 }}>
            <CardBody>
              <h5>Total Quote Count</h5>
              <h6>{quotation?.count || 0}</h6>
            </CardBody>
          </Card>
        </Col>
        <Col md={6}>
          <Card style={{ height: 120, borderRadius: 15 }}>
            <CardBody>
              <h5>Total Quote Amount</h5>
              <h6 className="font-size-16 text-muted d-flex align-items-center justify-content-start">
                <i className="bx bx-rupee text-primary font-size-18" />{" "}
                {quotation?.total_value || 0}
              </h6>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg={`${QDetails ? "8" : "12"}`}>
          <Card>
            <CardBody>
              <ToolkitProvider
                keyField="id"
                columns={columns}
                data={quotationData}
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                      <div
                        className="btn-group mt-2 mt-xl-0"
                        role="group"
                        aria-label="Basic radio toggle button group"
                      >
                        {tableTitles.map((head, key) => (
                          <Fragment key={key}>
                            <input
                              type="radio"
                              className="btn-check"
                              name="btnradio"
                              id={head.value + key}
                              autoComplete="off"
                              checked={sort === head.value}
                              onChange={() => listChange(head.value)}
                            />
                            <label
                              className="btn btn-success d-flex align-items-center w-100"
                              htmlFor={head.value + key}
                              style={{ whiteSpace: "nowrap" }}
                            >
                              {head.title}
                            </label>
                          </Fragment>
                        ))}
                      </div>

                      <div
                        className="btn-group mt-2 mt-xl-0 ms-2"
                        role="group"
                        aria-label="Document type toggle button group"
                      >
                        {documentType.map((head, key) => (
                          <Fragment key={key}>
                            <input
                              type="radio"
                              className="btn-check"
                              name="docTypeFilter"
                              id={"docType" + head.value + key}
                              autoComplete="off"
                              checked={documentTypeFilter === head.value}
                              onChange={() => setDocumentTypeFilter(head.value)}
                            />
                            <label
                              className="btn btn-info d-flex align-items-center w-100"
                              htmlFor={"docType" + head.value + key}
                              style={{ whiteSpace: "nowrap" }}
                            >
                              {head.title}
                            </label>
                          </Fragment>
                        ))}
                      </div>

                      {/* Category Filter */}
                      <div
                        className="btn-group mt-2 mt-xl-0 ms-2"
                        role="group"
                        aria-label="Category filter button group"
                      >
                        {categoryTypes.map((head, key) => (
                          <Fragment key={key}>
                            <input
                              type="radio"
                              className="btn-check"
                              name="categoryFilter"
                              id={"cat" + head.value + key}
                              autoComplete="off"
                              checked={categoryFilter === head.value}
                              onChange={() => setCategoryFilter(head.value)}
                            />
                            <label
                              className="btn btn-warning d-flex align-items-center w-100"
                              htmlFor={"cat" + head.value + key}
                              style={{ whiteSpace: "nowrap" }}
                            >
                              {head.title}
                            </label>
                          </Fragment>
                        ))}
                      </div>
                      <div className="mt-2 mt-xl-0 ms-2">
                        <Link to={`/quotation/create`}>
                          <Button color="success">
                            {" "}
                            <i className="bx bx-plus" />
                            Create Quotation
                          </Button>
                        </Link>
                      </div>
                    </div>

                    <Row className="mb-2 align-items-center">
                      <Col lg="4" md="6" className="mb-2">
                        <div className="search-box me-2 d-inline-block w-100">
                          <div className="position-relative">
                            <form
                              className="app-search d-lg-block"
                              onChange={e => handleSearch(e)}
                            >
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search..."
                                  defaultValue={searchText}
                                />
                                <span className="bx bx-search-alt" />
                              </div>
                            </form>{" "}
                          </div>
                        </div>
                      </Col>
                      <Col lg="8" md="12" className="mb-2">
                        <div className="d-flex align-items-center justify-content-end">
                          <div className="d-flex sortWrapper mx-2 align-items-center">
                            <p
                              className="mb-0 pb-0 mx-1"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              Sort By Date :
                            </p>
                            <AvForm>
                              <div className="d-flex date_wrapper">
                                <div className="d-flex align-items-start position-relative">
                                  <AvField
                                    name="dateRange"
                                    type="date"
                                    validate={{
                                      dateRange: {
                                        start: { value: -5, units: "years" },
                                        end: { value: 5, units: "years" },
                                      },
                                    }}
                                    onChange={e =>
                                      setFinalDateFormated({
                                        ...finalDateFormated,
                                        from: e.target.value,
                                      })
                                    }
                                    value={finalDateFormated.from}
                                  />
                                  <button
                                    onClick={() =>
                                      setFinalDateFormated({
                                        ...finalDateFormated,
                                        from: "",
                                      })
                                    }
                                    type="button"
                                    className="btn btn-white editable-cancel date_close btn-sm"
                                  >
                                    <i className="mdi mdi-close text-danger "></i>
                                  </button>
                                </div>
                                <div className="d-flex align-items-start position-relative">
                                  <AvField
                                    name="dateRange"
                                    className="mx-1"
                                    type="date"
                                    validate={{
                                      dateRange: {
                                        start: { value: -5, units: "years" },
                                        end: { value: 5, units: "years" },
                                      },
                                    }}
                                    onChange={e =>
                                      setFinalDateFormated({
                                        ...finalDateFormated,
                                        to: e.target.value,
                                      })
                                    }
                                    value={finalDateFormated.to}
                                  />
                                  <button
                                    onClick={() =>
                                      setFinalDateFormated({
                                        ...finalDateFormated,
                                        to: "",
                                      })
                                    }
                                    type="button"
                                    className="btn btn-white editable-cancel date_close-2 btn-sm"
                                  >
                                    <i className="mdi mdi-close text-danger "></i>
                                  </button>
                                </div>
                              </div>
                            </AvForm>
                          </div>
                        </div>
                      </Col>
                      <Col lg="2.5" md="6" className="mb-2" style={{ minWidth: "170px" }}>
                        <Select
                          value={
                            staffFilter === "all" || !staffFilter
                              ? { value: "all", label: "All Staff" }
                              : staffOptions.find(o => o.value === staffFilter) || null
                          }
                          onChange={option => {
                            setStaffFilter(option ? option.value : "all")
                            setPage(1)
                          }}
                          options={staffOptions}
                          placeholder="Filter by Staff"
                          classNamePrefix="select2-selection"
                          isClearable={false}
                        />
                      </Col>
                      <Col lg="2.5" md="6" className="mb-2" style={{ minWidth: "170px" }}>
                        <Select
                          value={
                            clientFilter === "all" || !clientFilter
                              ? { value: "all", label: "All Clients" }
                              : clientOptions.find(o => o.value === clientFilter) || null
                          }
                          onChange={option => {
                            setClientFilter(option ? option.value : "all")
                            setPage(1)
                          }}
                          options={clientOptions}
                          placeholder="Filter by Client"
                          classNamePrefix="select2-selection"
                          isClearable={false}
                        />
                      </Col>

                      {/* <Col
                        md="2"
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                        }}
                      >
                        {window.location.search && (
                          <Link
                            to="/quotations"
                            className="btn btn-light btn-sm"
                          >
                            See All
                            <i className="bx bx-right "></i>
                          </Link>
                        )}
                      </Col> */}
                    </Row>

                    {loading ? (
                      <Spinner color="secondary" className="d-block m-auto" />
                    ) : (
                      <>
                        <Row>
                          <Col xl="12">
                            <div className="table-responsive">
                              <BootstrapTable
                                keyField={"id"}
                                responsive
                                bordered={false}
                                striped={false}
                                defaultSorted={defaultSorted}
                                selectRow={selectRow}
                                classes={"table align-middle table-nowrap"}
                                headerWrapperClasses={"thead-light"}
                                {...toolkitProps.baseProps}
                              />
                            </div>
                            <p>
                              {quotation?.results?.length === 0 && " No data"}
                            </p>
                          </Col>
                        </Row>
                        <MyPagination
                          totalPages={pages}
                          page={page}
                          setPage={setPage}
                        />
                      </>
                    )}
                  </React.Fragment>
                )}
              </ToolkitProvider>
            </CardBody>
          </Card>
        </Col>
        {QDetails && (
          <Col lg={4}>
            <QuotationDetails quotationId={QDetails} />
          </Col>
        )}
      </Row>
    </React.Fragment>
  )
}

export default Quotation
